import React from 'react';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/mockData';
import { ArrowRight, Clock } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const BlogCard = ({ post, index }) => {
  const card = useScrollAnimation({ threshold: 0.15 });
  const navigate = useNavigate();
  const delay = index + 1;

  return (
    <div
      ref={card.ref}
      data-testid={`blog-card-${post.id}`}
      onClick={() => navigate(`/blog/${post.slug}`)}
      className={`group relative rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 card-hover-premium cursor-pointer scroll-fade-up scroll-delay-${delay} ${card.isVisible ? 'scroll-visible' : ''}`}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover blog-card-img"
        />
        <div className="absolute inset-0 bg-[#030308]/60 group-hover:bg-[#030308]/40 transition-colors duration-500" />
        <div className="absolute top-4 left-4">
          <span className="bg-indigo-500/80 text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-md">
            {post.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex items-center gap-2 mb-3">
          <Clock className="w-3.5 h-3.5 text-slate-500" />
          <span className="text-xs text-slate-500">{post.readTime}</span>
        </div>

        <h3 className="text-lg font-bold tracking-tight text-white mb-3 group-hover:text-amber-400 transition-colors leading-snug" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {post.title}
        </h3>

        <p className="text-sm text-slate-400 leading-relaxed mb-4">
          {post.excerpt}
        </p>

        <div className="flex items-center gap-2 text-indigo-400 group-hover:text-amber-400 transition-colors font-bold text-sm uppercase tracking-wider">
          Read More
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </div>
  );
};

const BlogSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="blog" data-testid="blog-section" className="py-24 md:py-32 bg-[#0A0A12] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div ref={header.ref} className={`max-w-2xl mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-amber-500 mb-3 block font-bold">Resources</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-white mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Knowledge Is <span className="text-gradient-primary">Power.</span>
          </h2>
          <p className="text-base text-slate-300 leading-relaxed">
            Free guides and insights from our trademark attorneys. Stop guessing and start making informed decisions about your brand protection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((post, index) => (
            <BlogCard key={post.id} post={post} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
